import { get } from 'lodash';

import { Expression } from '@skinsoft/types';

// Selectors for Manifestation type

export const id = (expression: Expression) => get(expression, 'id')

export const work = (expression: Expression) => {
    return get(expression, ['expressionSchema', 'referentWork', 'ref']) ??
        get(expression, ['expressionSchema', 'referentWork'])
}
